/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changepassword1Inputs */

const en_changepassword1 = /** @type {(inputs: Changepassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change Password`)
};

const de_changepassword1 = /** @type {(inputs: Changepassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kennwort ändern`)
};

/**
* | output |
* | --- |
* | "Change Password" |
*
* @param {Changepassword1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const changepassword1 = /** @type {((inputs?: Changepassword1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changepassword1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_changepassword1(inputs)
	return de_changepassword1(inputs)
});
export { changepassword1 as "changePassword" }